<template>
  <div class="layout-box">
    <LayoutHeader :headtitle="types+'详情'"></LayoutHeader>
    <div class="secondary-content">
<!--      <div class="news-list">-->
<!--        <span class="news-list-tit"><i class="iconfont icon-xinwen1"></i>资讯列表</span>-->
<!--        <ul>-->
<!--          <li v-for="(item,index) in datas" :key="index" :class="ids==(index+1)?'on':''" @click="getnewdetail(index+1)"><em>{{ index+1 }}</em><a>{{item.tit}}</a></li>-->
<!--        </ul>-->
<!--      </div>-->
      <GoBack v-if="isgoback"></GoBack>
      <div class="new-detail">
        <div class="new-detail-title" v-if="titles">{{ titles }}</div>
        <p class="new-detail-time" v-if="times">{{ times }}</p>
        <div class="new-detail-content">
          <News9 v-if="content==9"></News9>
          <News10 v-if="content==10"></News10>
          <News11 v-if="content==11"></News11>
          <News12 v-if="content==12"></News12>
          <News13 v-if="content==13"></News13>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
import News9 from "../new/news9";
import News10 from "../new/news10";
import News11 from "../new/news11";
import News12 from "../new/news12";
import News13 from "../new/news13";
export default {
  name: 'Indunowledgedetails',
  components:{
    LayoutHeader,
    GoBack,
    News9,
    News10,
    News11,
    News12,
    News13,
  },
  data () {
    return {
      titles:'',
      times:'',
      content:'',
      types:'',
      isgoback:true,
      ids:0,
      datas:[
        {id:9,tit:'【标准】4项化纤推荐性国标、17项化纤行业标准发布',time:'2022-05-06 09:59',gob:true,cont:'',types:'行业标准'},
        {id:10,tit:'提高大比例涤纶混纺纱质量的工艺措施',time:'2022-07-04 13:47',gob:false,cont:'',types:'行业知识'},
        {id:11,tit:'我国绿色纺织品的现状及发展趋势',time:'2022-08-13 16:17',gob:false,cont:'',types:'行业知识'},
        {id:12,tit:'复合芳香涤纶纤维纱及其产品的研制',time:'2021-02-01 09:14',gob:false,cont:'',types:'行业知识'},
        {id:13,tit:'细特涤纶竹纤维混纺纱的品种开发',time:'2020-12-10 09:14',gob:false,cont:'',types:'行业知识'},
      ]
    }
  },
  created() {
    this.ids=this.$route.query.id
    this.getnewdetail(this.ids)
  },
  methods: {
    getnewdetail(ids){
      this.ids=ids
      let getdata=this.datas[this.datas.findIndex((item) => item.id*1 === ids*1)]||{}
      if(getdata){
        this.titles=getdata.tit
        this.times=getdata.time
        this.content=ids
        this.isgoback=getdata.gob
        this.types=getdata.types
      }
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
  min-height: calc(100% - 20px);
}

.gotob{
  width: 49px;
  height: 40px;
  padding-left: 35px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #0B42AF;
  position: absolute;
  right: 0;
  top:-40px;
  font-size: 16px;
  color: #DBE1F1;
  line-height: 40px;
  cursor: pointer;
  background-image: url("../../assets/goto.fw.png");
  background-repeat: no-repeat;
  background-position: 9px 10px;
}

.gotob:hover{
  text-shadow: 2px 2px 4px rgba(0,0,0,.4);
  background-color: #0B3999;
}

.new-detail{
  padding: 30px 48px;
  width: calc(100% - 96px);
  height: calc(100% - 60px);
}

.new-detail-title{
  font-size: 24px;
  width: 100%;
  text-align: center;
  line-height: 32px;
  height: 32px;
  padding: 12px 0 20px 0;
  border-bottom: 1px solid #4F8EF9;
  color: #FFFFFF;
}

.new-detail-time{
  width: 100%;
  text-align: center;
  color: #A6C6FC;
  font-size: 14px;
  margin-top: 12px;
}

.new-detail-content{
  width: 100%;
  font-size: 16px;
  color: #fff;
  line-height: 217%;
  margin-top: 40px;
}

.news-list{
  width: 270px;
  position: fixed;
  height: calc(100% - 190px);
  top: 170px;
  left: 50%;
  margin-left: -840px;
  background: #0A47B6;
  overflow: auto;
}

.news-list::-webkit-scrollbar{
  display: none;
}

.news-list-tit{
  background: #fff;
  display: block;
  width: calc(100% - 40px);
  color: #0A47B6;
  margin: 12px auto;
  font-size: 16px;
  line-height: 32px;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 6px;
  box-shadow: 1px 4px 8px 0 rgba(0,0,0,.2);
}

.news-list-tit i{
  font-size: 24px;
  display: inline-block;
  vertical-align: top;
  margin-right: 7px;
  margin-top: -1px;
}

.news-list em{
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  color: #0A47B6;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  margin-right: 5px;
  vertical-align: top;
  margin-top: 1px;
}

.news-list .on{
  background: #07358B;
  border-radius: 6px;
}

.news-list a{
  color: #fff;
  width: calc(100% - 26px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  cursor: pointer;
}

.news-list a:hover{
  text-decoration: underline;
}

.news-list ul{
  margin: 5px 20px;
  position: relative;
}

.news-list li{
  padding: 10px 0 10px 5px;
}

</style>




// WEBPACK FOOTER //
// src/views/secondary/secondary-indunowledge-details.vue